import { ICustomer } from "./types";

interface CustomerPageProps {
  customer: ICustomer | null;
}

const CustomerPage = (props: CustomerPageProps) => {
  const { customer } = props;
  return <></>;
};

export default CustomerPage;
